import { useEffect, useState } from 'react';

import { chatVisitor, onOpenChatWidget, useChatVisitor } from '~/lib/chat-visitor';
import { ChatLauncher } from './ChatLauncher';
import { ChatPanel } from './ChatPanel';

/** Hoe vaak de bezetting wordt ververst zolang het paneel openstaat en er nog
 *  geen gesprek loopt. Traag genoeg om niets te kosten, snel genoeg dat je niet
 *  op "chat starten" drukt terwijl de laatste medewerker net wegging. */
const AVAILABILITY_POLL_MS = 30_000;

let mountCount = 0;

/**
 * De chatwidget. Wordt één keer gemonteerd, in de padloze publieke layout-route
 * (app/routes/public/layout.tsx) — niet in PublicLayout of PublicShell, want
 * artikel.tsx gebruikt de één en de rest de ander, en dan zouden er op sommige
 * pagina's twee knoppen en twee verbindingen zijn.
 */
export function ChatWidget() {
  const state = useChatVisitor();
  // Alles wat uit opslag of uit een verzoek komt blijft weg tot na de hydratatie:
  // de server kent die waarden niet en anders krijg je een mismatch. Zelfde
  // patroon als ThemeToggle.tsx:34-35 ("vóór hydratatie neutraal").
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    if (import.meta.env.DEV && ++mountCount > 1) {
      console.error('[chat] de widget is meer dan één keer gemonteerd — controleer app/routes.ts');
    }

    // Liep er een gesprek vóór deze paginalading? Dan doorpakken. Het paneel
    // blijft dicht; de bezoeker heeft er niet om gevraagd.
    void chatVisitor.resume();

    return () => {
      chatVisitor.teardown();
      if (import.meta.env.DEV) mountCount--;
    };
  }, []);

  // Openen vanaf elders (de Contact-knop in de kopbalk).
  useEffect(() => onOpenChatWidget(() => void chatVisitor.open()), []);

  // Bezetting verversen zolang er iets te kiezen valt.
  useEffect(() => {
    if (!state.panelOpen) return;
    if (state.phase !== 'available' && state.phase !== 'unavailable') return;
    const timer = setInterval(() => void chatVisitor.refreshAvailability(), AVAILABILITY_POLL_MS);
    return () => clearInterval(timer);
  }, [state.panelOpen, state.phase]);

  return (
    <>
      <ChatLauncher state={state} mounted={mounted} />
      {mounted && state.panelOpen && <ChatPanel state={state} />}
    </>
  );
}
